import { Box, Button, Card, CardBody, Flex, Grid, GridItem, Icon, Image, Separator, Text, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';
import ContentCard from '../../../components/layout/ContentCard';
import BaseDialog from '../../../components/BaseDialog';
import CreateMailboxForm from '../forms/CreateMailboxForm';
import useUpdateMailbox from '../hooks/useUpdateMailbox';
import { CiEdit } from "react-icons/ci";
import { IMailbox } from '../types';

const UpdateMailboxDialog = ({ mailbox }: { mailbox: IMailbox }) => {
    const [dialogOpen, setDialogOpen] = useState(false)

    const { updateMailbox } = useUpdateMailbox();

    return (
        <BaseDialog
            open={dialogOpen}
            setOpen={setDialogOpen}
            trigger={
                <Icon size='md' cursor='pointer'>
                    <CiEdit />
                </Icon>
            }
            title={"Update IMAP server"}
        >
            <CreateMailboxForm 
                onSubmit={updateMailbox} 
                callback={() => setDialogOpen(false)}
                initialValues={mailbox}
            />
        </BaseDialog>
    )
}

export default UpdateMailboxDialog;